import React from "react";
import { AgGridReact } from "ag-grid-react";
import Loader from "rsuite/esm/Loader";
import NoDataFound from "./common/NoDataFound";
import { isEmpty } from "../../../../utils/utils";


const InfraUsagePanel = ({  loading, infraDetails
}) => {

  const infraColumnDefs = [
    {
      headerName: "Resource",
      field: "name",
      width: 150,
    },
    {
      headerName: "Total",
      field: "total",
      width: 100,
    },
    {
      headerName: "Consumed",
      field: "consumed",
      width: 120,
    },
    {
      headerName: "Available",
      field: "available",
      width: 120,
    },
    {
      headerName: "Usage %",
      field: "percentage",
      width: 100,
    },
    {
      headerName: "Extra",
      field: "extra",
      width: 100,
    },
  ];

  const infraRowData = Object.values(infraDetails || {}).map((item) => ({
    name: item.name || "N/A",
    total: item.total || "N/A",
    consumed: item.consumed || "N/A",
    available: item.available || "N/A",
    percentage: item.percentage || "N/A",
    extra: item.extra || "N/A",
  }));

  return (
    <React.Fragment>
      <div role="tabpanel" className="tab-pane" id="revenue-and-billing">
        <div className="flex flex-col gap-12">
          <div style={{ backgroundColor: "white" }}>
            {loading && (
              <div className="accordion-component p-8 flex justify-center">
                <Loader content="Loading Content..." />
              </div>
            )}
            {
              !loading &&
              isEmpty(infraDetails) && (
                <NoDataFound />
              )
            }
          </div>
          {!loading && infraRowData.length > 0 && (
            <div className="accordion-component p-8">
              <div className="ag-theme-alpine" style={{ height: 530 }}>
                <AgGridReact
                  columnDefs={infraColumnDefs}
                  rowData={infraRowData}
                  defaultColDef={{
                    resizable: true,
                    sortable: true,
                  }}
                  rowHeight={40}
                  suppressContextMenu
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default InfraUsagePanel;


// WEBPACK FOOTER //
// ./src/components/crm/leads/components/InfraUsagePanel.js